import { render, staticRenderFns } from "./Portalinformationen.vue?vue&type=template&id=20479b78&scoped=true"
import script from "./Portalinformationen.vue?vue&type=script&lang=js"
export * from "./Portalinformationen.vue?vue&type=script&lang=js"
import style0 from "./Portalinformationen.vue?vue&type=style&index=0&id=20479b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20479b78",
  null
  
)

export default component.exports